import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const mix: RouteRecordItem = {
  path: '/mix',
  name: 'Mix',
  component: LAYOUT,
  redirect: { name: 'MixList' },
  meta: {
    orderNo: 10,
    icon: 'tabler:layers-linked',
    title: t('routes.mix.混流管理'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'list',
      name: 'MixList',
      component: () => import('@/pages/mix/index.vue'),
      meta: {
        title: t('routes.mix.混流管理'),
        icon: 'carbon:transform-binary',
      },
    },
  ],
}

export default mix
